import { Injectable } from '@angular/core';

@Injectable()
export class AlloxCommon {

  /**
  * 受け取った値にテキストを追加して返す。
  * @param { string } name テキストを付与する文字列
  */
  public addCopyWordToName(name: string) {
    return 'コピー_' + name;
  }
}
